import { setUserProperties } from 'firebase/analytics';
import { getFirebaseAnalytics } from './installFirebase.util';
import { logger } from '@/shared/common/utils/logger.util';
import type { UserAnalyticsProperties } from '../types/analytics.types';

/**
 * Sincroniza las propiedades del usuario con Firebase Analytics para segmentación y análisis.
 *
 * @param {UserAnalyticsProperties} properties - Propiedades del usuario a sincronizar
 * @returns {Promise<void>}
 */
export async function syncUserProperties(properties: UserAnalyticsProperties): Promise<void> {
  const analytics = await getFirebaseAnalytics();

  if (!analytics) {
    logger.warn('[Analytics] Not supported in this environment');
    return;
  }

  setUserProperties(analytics, {
    b2b_user_id: properties.b2bUserId,
    company_id: properties.companyId,
    origin_country: properties.originCountry.toLowerCase(),
    ...(properties.companyCreatedAt && { company_created_at: properties.companyCreatedAt }),
    ...(properties.kycStatus && { kyc_status: properties.kycStatus }),
    ...(properties.complianceStatus && { compliance_status: properties.complianceStatus }),
  });
}
